// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"9c796736","325":"ff4169ca","357":"627ce7d2","419":"0fb2d10c","490":"005d2b04","553":"f30bdf8c","720":"8b096e6f","787":"b32fb4f2","897":"c9579e35"}[chunkId] + ".chunk.js";
};